module.exports = __webpack_public_path__ + "img/map_studio.6ce8ad95.jpg";